import Logger from './Logger';
import serviceUtils from './serviceUtils';

/* eslint-disable consistent-return */
/* eslint-disable no-underscore-dangle */

const hookEmailInput = (emailId) => {
  try {
    const { _ltk } = window;
    _ltk.SCA.CaptureEmail(emailId);
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const hookPhoneInput = (phoneId) => {
  try {
    const { _ltk } = window;
    _ltk.SCA.CapturePhoneNumber(phoneId);
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const identifyUser = (userInfo) => {
  try {
    const { _ltk } = window;
    _ltk.SCA.Update('email', userInfo.email);
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const pageView = () => {
  try {
    const { _ltk } = window;
    _ltk.Activity.AddPageBrowse();
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const viewedProduct = (product, isProduct) => {
  try {
    const { _ltk } = window;
    let { sku } = product;
    if (!isProduct) {
      sku = serviceUtils.getSubscriptionSku(product);
    }
    _ltk.Activity.AddProductBrowse(sku);
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const updatedCart = (cart) => {
  try {
    const { _ltk } = window;
    const includeViewedOn = false;
    const items = serviceUtils.getDataForCart(cart, includeViewedOn);
    let isDmeCart = false;
    if (items.length) {
      for (const item of items) {
        const {
          listrakSku,
          Quantity,
          listrakPrice,
          listrakName,
          ImageURL,
          ProductURL,
        } = item;
        if (item.isBreastPump) {
          isDmeCart = true;
        }

        _ltk.SCA.AddItemWithLinks(
          listrakSku,
          Quantity,
          listrakPrice,
          listrakName,
          ImageURL,
          ProductURL,
        );
      }
      const overallTotal = cart?.subCosts?.overallTotal || 0;
      const shipping = cart?.subCosts?.shipping || 0;

      if (isDmeCart) {
        _ltk.SCA.Meta1 = 'isDmeCart';
      }

      _ltk.SCA.Total = parseFloat(overallTotal - shipping).toFixed(2);
      _ltk.SCA.Submit();
    } else {
      _ltk.SCA.ClearCart();
    }
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const transactionComplete = (purchaseData, cartInfo) => {
  try {
    const { _ltk } = window;

    let purchaseId = purchaseData.res.justPurchasedPurchaseId;
    if (purchaseData.isPostPurchasePurchase) {
      purchaseId = `${purchaseId}-postPurchaseUpsell`;
    }

    const { total, shipping, taxesAndFees, subTotal } = purchaseData;
    const { billingAddress, billingValues } = cartInfo;
    const name = {
      first: billingAddress?.name?.first || billingValues?.firstName,
      last: billingAddress?.name?.last || billingValues?.lastName,
    };
    const purchaser = purchaseData.res?.purchaser || cartInfo.purchaser;
    const email = purchaser.email || purchaser.guestCheckoutEmail;

    _ltk.Order.SetCustomer(email, name.first, name.last);
    _ltk.Order.OrderNumber = purchaseId;
    _ltk.Order.ItemTotal = parseFloat(subTotal).toFixed(2);
    _ltk.Order.ShippingTotal = parseFloat(shipping).toFixed(2);
    _ltk.Order.HandlingTotal = 0;
    _ltk.Order.TaxTotal = parseFloat(taxesAndFees).toFixed(2);
    _ltk.Order.OrderTotal = parseFloat(total).toFixed(2);

    const items = serviceUtils.getDataForCart(cartInfo);
    if (cartInfo.productsAndDetails?.length) {
      for (const item of items) {
        const { listrakSku, Quantity, listrakPrice } = item;
        _ltk.Order.AddItem(listrakSku, Quantity, listrakPrice);
      }
    }
    _ltk.Order.Submit();
  } catch (e) {
    Logger.error(e);
    return e;
  }
};

const dmeFormStarted = (email, phoneNumber) => {
  try {
    const { _ltk } = window;
    _ltk.CustomEvents.submit({
      eventUID: '0d0d1c5e-8570-4bd7-8cb3-ab5f86682cf3',
      identifiers: [
        {
          identifierType: 'EmailAddress',
          identifierValue: email,
        },
        {
          identifierType: 'PhoneNumber',
          identifierValue: phoneNumber,
        },
      ],
      dataFields: {
        Email: email,
      },
    });
  } catch (err) {
    Logger.error(err);
  }
};

const dmeItemSelectionStarted = (email, phoneNumber, matchedPartner) => {
  try {
    const { _ltk } = window;
    _ltk.CustomEvents.submit({
      eventUID: '7d5728ae-45a8-4110-9793-713afd4c7362',
      identifiers: [
        {
          identifierType: 'EmailAddress',
          identifierValue: email,
        },
        {
          identifierType: 'PhoneNumber',
          identifierValue: phoneNumber,
        },
      ],
      dataFields: {
        BreastPumpPartner: matchedPartner,
      },
    });
  } catch (err) {
    Logger.error(err);
  }
};

export default {
  hookEmailInput,
  hookPhoneInput,
  pageView,
  identifyUser,
  viewedProduct,
  updatedCart,
  transactionComplete,
  dmeFormStarted,
  dmeItemSelectionStarted,
};
